import createStyles from '@material-ui/core/styles/createStyles';
import {WithStyles} from '@material-ui/core/styles/withStyles';

export const styles = () =>
  createStyles({
    root: {
      transition: 'all 1s',
      textAlign: 'center',
    },
    legend: {
      mixBlendMode: 'difference',
      color: 'white',
    },
  });

export type Styles = WithStyles<typeof styles>;
